import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Venta`

export function buscarPorUsuario(idUsuario, search) {
  return http.get(`${API_ENDPOINT}/BuscarPorUsuario/${idUsuario}/${search}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las ventas.',
      tipoError: 'ventas'
    }
  })
}

export function actualizar(pedido) {
  return http.put(API_ENDPOINT, pedido)
}

export function insertar(pedido) {
  return http.post(API_ENDPOINT, pedido)
}

export function eliminar(idPedido) {
  return http.delete(`${API_ENDPOINT}/${idPedido}`)
}

export function buscarPorEmpresa(empid, search) {
  return http.get(`${API_ENDPOINT}/BuscarPorEmpresa/${empid}/${search}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las ventas.',
      tipoError: 'ventas'
    }
  })
}
